import { defaultHttpClient } from '../../httpClient';
import type { PostEmailLoginRequest, PostEmailLoginResponse } from './types';

/**
 * - 이메일 로그인 API
 * - 성공 시 멤버 JWT 토큰(token)을 반환한다.
 */
export const postEmailLogin = (params: PostEmailLoginRequest) => {
  return defaultHttpClient
    .request<PostEmailLoginResponse>({
      method: 'POST',
      url: '/api/v2/login/',
      data: params,
    })
    .then(result => result.data);
};
